// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"21fe600e","453":"44c9a9d5"}[chunkId] + ".chunk.js";
};